import Swiper from "swiper";
import {Autoplay} from "swiper";
import {BREAKPOINT_SM, BREAKPOINT_MD, BREAKPOINT_LG} from "../globals";

const SLIDES_PER_VIEW_SM = 4;
const SLIDES_PER_VIEW_MD = 5;
const SLIDES_PER_VIEW_LG = 6;

export default class SliderAlbert {
	
	constructor(selector) {

		const swiperContainer = document.querySelector('.slider-albert');
		
		if (swiperContainer === null ) return;

		this.swiperDelay = swiperContainer.getAttribute('data-slider-delay');
				
		/** @var {SwiperOptions} */
		const config = {
			modules: [Autoplay],
			slidesPerView: 2,
			breakpoints: {
				[BREAKPOINT_SM]: {
					slidesPerView: SLIDES_PER_VIEW_SM,
				},
				[BREAKPOINT_MD]: {
					slidesPerView: SLIDES_PER_VIEW_MD,
				},
				[BREAKPOINT_LG]: {  
					slidesPerView: SLIDES_PER_VIEW_LG,
				}
			},
			centerInsufficientSlides: true,
			speed: 1000,
			autoplay: {
				delay: this.swiperDelay * 1000, // in miliseconds
				disableOnInteraction: false,
			},
			grabCursor: true,
		};
		
		this.slider = new Swiper(selector, config);
	}

	static init() {
		const sliders = document.querySelectorAll('.slider-albert .swiper');
		sliders.forEach(slider => new SliderAlbert(slider));
	}
}